//function to pad date numbers for profile API format
const padDatePart = (value) => String(value).padStart(2, "0");

//function to parse profile dob from API into a picker-safe Date
export const parseProfileDobForPicker = (value) => {
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value !== "string") return null;

  const ddMmYyyyMatch = value.match(/^(\d{2})-(\d{2})-(\d{4})$/);
  if (ddMmYyyyMatch) {
    const [, day, month, year] = ddMmYyyyMatch;
    const parsedDate = new Date(Number(year), Number(month) - 1, Number(day));
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
  }

  const parsedDate = new Date(value);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

//function to serialize profile dob into the current API format
export const serializeProfileDobForApi = (value) => {
  const parsedDate = parseProfileDobForPicker(value);
  if (!parsedDate) return "";

  return `${padDatePart(parsedDate.getDate())}-${padDatePart(
    parsedDate.getMonth() + 1
  )}-${parsedDate.getFullYear()}`;
};

//function to format profile dob for read-only display
export const formatProfileDobForDisplay = (value) => {
  const parsedDate = parseProfileDobForPicker(value);
  if (!parsedDate) return "NA";

  return `${padDatePart(parsedDate.getDate())}/${padDatePart(
    parsedDate.getMonth() + 1
  )}/${parsedDate.getFullYear()}`;
};
